import * as React from 'react';
import { memo } from 'react';

import noop from 'helper/noop';

export type RadioProps = {
	id: string;
	tag: string;
	name: string;
	label?: string;
	value: string;
	checked?: boolean;
	onChange: (value: string) => void;
	disabled?: boolean;
	hasBrightBackground?: boolean;
};

export type RadioState = {
	radioValue: void | string;
};

export class Radio extends React.Component<RadioProps, RadioState> {
	public static displayName = 'Radio';

	public static defaultProps = {
		onChange: noop,
		value: Date.now().toString(),
		disabled: false,
	};

	constructor(props: RadioProps) {
		super(props);

		this.state = {
			radioValue: undefined || props.value,
		};
	}

	public handleChange = (ev: React.MouseEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>) => {
		if (ev && ev.target instanceof HTMLInputElement) {
			this.props.onChange(ev.target.value);
		}
	};

	public render() {
		const {
			id,
			name,
			label,
			tag,
			value,
			disabled = false,
			checked = false,
			hasBrightBackground = false,
		} = this.props;

		const Tag: any = `${tag}`;

		return (
			<Tag
				className={`a-radio${disabled ? ' state-a-radio--disabled' : ''}${
					hasBrightBackground ? '' : ' a-radio--white'
				}`}
			>
				<input
					type="radio"
					id={id}
					name={name}
					value={value}
					disabled={disabled}
					checked={checked}
					onChange={this.handleChange}
				/>
				{label && <label htmlFor={id}>{label}</label>}
			</Tag>
		);
	}
}

export default memo(Radio);
